import React from "react";
import * as Icon from "react-bootstrap-icons";
import styles from "./ViewK1ActionCell.module.css";
import type { ClientDataItem } from "../../ClientsPage.types";

interface ViewK1ActionCellProps {
  data?: ClientDataItem;
  onViewDocuments?: (client: ClientDataItem) => void;
}

export const ViewK1ActionCell: React.FC<ViewK1ActionCellProps> = ({
  data,
  onViewDocuments,
}) => {
  if (!data) return <></>;

  const handleViewK1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onViewDocuments?.(data);
  };

  return (
    <button className={styles.viewK1Link} onClick={handleViewK1}>
      View K1 <Icon.ArrowRight className={styles.viewK1Arrow} />
    </button>
  );
};
